export type CSVField<T> = {
  header: string;
  key: (item: T) => string | number;
};

/**
 * Fonction utilitaire pour échapper les caractères spéciaux dans les cellules CSV
 */
const escapeCsvValue = (value: string | number): string => {
  const stringValue = String(value);
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

/**
 * Fonction générique pour télécharger des données au format CSV
 * @param data - Tableau de données à exporter
 * @param fields - Configuration des champs à exporter
 * @param filename - Nom du fichier (sans extension)
 */
export const downloadCSV = <T extends object>(
  data: T[],
  fields: CSVField<T>[],
  filename: string
): void => {
  // Créer les en-têtes
  const headers = fields.map(field => field.header);

  // Créer les lignes de données
  const rows = data.map(item => 
    fields.map(field => escapeCsvValue(field.key(item)))
  );

  // Assembler le CSV
  const csv = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');

  // Ajouter le BOM pour l'encodage UTF-8 correct
  const csvContent = '\ufeff' + csv;

  // Créer le blob et le lien de téléchargement
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  const today = new Date();
  const dateStr = today.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).split('/').reverse().join('');

  const timeStr = today.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit'
  }).replace(':', '');

  link.setAttribute('href', url);
  link.setAttribute('download', `export_${filename}_${dateStr}_${timeStr}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}; 